import type { CMSView } from "@firecms/core";
import {
  NAV_GROUP_PATH,
  NAV_GROUP_RANKINGS,
  NAV_GROUP_STATS,
} from "../collections/navigationGroups";
import { getAdminT } from "../i18n/getAdminT";
import { getAdminUiLocale } from "../i18n/getAdminUiLocale";
import { TableListView } from "../views/TableListView";
import { ParticipantProgressView } from "../views/ParticipantProgressView";
import { ContentInstallsView } from "../views/ContentInstallsView";
import { EventContentView } from "../views/EventContentView";
import { IndividualRankingView } from "../views/IndividualRankingView";
import { LearningStatsView } from "../views/LearningStatsView";
import { TeamRankingView } from "../views/TeamRankingView";
import type { AdminMode } from "./adminMode";

export function buildCMSViewsForMode(mode: AdminMode): CMSView[] {
  if (mode.kind === "hub") {
    return [];
  }

  if (mode.kind !== "event") {
    return [];
  }

  const t = getAdminT(getAdminUiLocale());

  return [
    {
      path: "map",
      name: t("eventContent.viewTitle"),
      description: t("eventContent.viewDescription"),
      icon: "Map",
      group: NAV_GROUP_PATH,
      view: <EventContentView eventId={mode.id} />,
    },
    {
      path: "event-stats",
      name: t("eventStats.viewTitle"),
      description: t("eventStats.viewDescription"),
      icon: "DataSaverOff",
      group: NAV_GROUP_STATS,
      view: <TableListView eventId={mode.id} />,
    },
    {
      path: "learning-stats",
      name: t("learningStats.viewTitle"),
      description: t("learningStats.viewDescription"),
      icon: "School",
      group: NAV_GROUP_STATS,
      view: <LearningStatsView eventId={mode.id} />,
    },
    {
      path: "individual-ranking",
      name: t("eventRanking.individualTitle"),
      description: t("eventRanking.individualDescription"),
      icon: "EmojiEvents",
      group: NAV_GROUP_RANKINGS,
      view: <IndividualRankingView eventId={mode.id} />,
    },
    {
      path: "team-ranking",
      name: t("eventRanking.teamTitle"),
      description: t("eventRanking.teamDescription"),
      icon: "Groups",
      group: NAV_GROUP_RANKINGS,
      view: <TeamRankingView eventId={mode.id} />,
    },
    {
      path: "participant-progress",
      name: t("participantProgress.viewTitle"),
      description: t("participantProgress.viewDescription"),
      icon: "Timeline",
      group: NAV_GROUP_STATS,
      view: <ParticipantProgressView eventId={mode.id} />,
    },
    {
      path: "content-installs",
      name: t("contentInstalls.viewTitle"),
      description: t("contentInstalls.viewDescription"),
      icon: "SystemUpdate",
      group: NAV_GROUP_STATS,
      view: <ContentInstallsView eventId={mode.id} />,
    },
  ];
}
